import { createSlice } from '@reduxjs/toolkit';

const formSlice = createSlice({
  name: 'form',
  initialState: {
    relationship: '',
  },
  reducers: {
    setFormData: (state, action) => {
      const { relationship } = action.payload;
      state.relationship = relationship;
    },
  },
});

export const { setFormData } = formSlice.actions;
export default formSlice.reducer;